<template>
  <v-toolbar id="userToolbar" fixed app
    color="amber" :clipped-left="$vuetify.breakpoint.lgAndUp">
    <v-toolbar-side-icon class="blue--text text--darken-2" @click="toggleNavigator"></v-toolbar-side-icon>
    <div class="u-name body-1 blue-grey--text text--darken-4 mr-3">
      <span class="ruby">{{ printUserKana }}</span>
      <span class="">{{ `${printUserName}様` }}</span>
    </div>
    <v-spacer></v-spacer>
    <v-menu bottom left offset-y :close-on-content-click="false">
      <v-btn icon slot="activator" color="blue--text text--darken-2"><v-icon>apps</v-icon></v-btn>
      <v-list>
        <AccountModal />
        <v-list-tile @click.stop="logout">
          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'sign-out']" /></v-list-tile-avatar>
          <v-list-tile-content>ログアウト</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    <ConfirmModal ref="confirm"/>
  </v-toolbar>
</template>

<script>
import ConfirmModal from '@/components/modals/confirm'
import AccountModal from './components/toolkits/account'

export default {
  name: 'userToolbar',
  components: {
    AccountModal,
    ConfirmModal
  },
  data () {
    return {
      config: {
        status: {
          user: false
        },
        confirm: {
          message: ''
        }
      },
      meta: {
        login: {
          icons: {
            empty: ['fal', 'circle'],
            active: ['fal', 'check-circle'],
            cancel: ['fal', 'ban']
          }
        }
      },
      store: {
        login: {
          token: '',
          status: ''
        },
        arranges: []
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
    },
    update: function () {
    },
    get: function () {
    },
    logout: function () {
      this.$router.push('/logout')
    },
    toggleNavigator: function () {
      this.$emit('emit', {
        dest: 'navigator',
        action: 'toggle',
        data: null
      })
    },
    develop: function () {
    }
  },
  computed: {
    hasArranges () {
      return (this.store.arranges.length !== 0)
    },
    printUserName () {
      let name = this.$store.getters['user/get']('name').join(' ')
      return (name === ' ') ? '' : name
    },
    printUserKana () {
      return this.$store.getters['user/get']('kana').join(' ')
    },
    printAuthorName () {
      return this.$store.getters['user/get']('author').name[0]
    }
  }
}
</script>

<style lang="scss">
#userToolbar {
  .u-name {
    position: relative;
    .ruby {
      position: absolute;
      top: -1em;
      left: 0;
      font-size: .6em;
      white-space: nowrap;
    }
  }
}
</style>
